// @ai-generated 2026-08-19T06:57:20+00:00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import { defineToolCallRenderer } from '@copilotkit/react-core/v2';
import { ToolCallCardShell } from './ToolCallCardShell';
import { resolveToolCallState } from './toolCallStatus';

/**
 * Fallback tool-call renderer, matching every tool (`name: "*"`) that has no specialized card.
 * Unlike CopilotKit's default wildcard it renders the same in every status, so a completed call
 * stays in the transcript instead of dissolving into the assistant's next text turn.
 *
 * States that the call happened and how it went, and — when it failed — why, which the shell reads
 * off the result. A successful call's payload stays out of the transcript: without knowing the tool
 * there is nothing to say about it that belongs in a conversation.
 */
function ToolCallCard({ name, result, status }: { name: string; result: unknown; status: unknown }) {
    return <ToolCallCardShell title={name} state={resolveToolCallState(status, result)} result={result} />;
}

export const ChatToolCallCard = defineToolCallRenderer({
    name: '*',
    render: ToolCallCard,
});
